import UXCPDescription from './UXCPDescription';

export default UXCPDescription;
